// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"1f033ed0","173":"3e4690be","174":"2db89b11","453":"17d4cceb","500":"a36c9ca4","908":"c3f768bc"}[chunkId] + ".chunk.js";
};